import { FC, Suspense } from "react";
import { Provider } from "react-redux";
import { LoadingSpinner } from "./components/core/Loading";
import Routing from "./routes/Routes";
import store from "./services/redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./i18n/i18n";
import { initLocale } from "./i18n/i18n";
import { TierProvider } from "./context/tier.context";

const App: FC = () => {
  initLocale()
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Provider store={store}>
        <TierProvider>
          <ToastContainer />
          <Routing />
        </TierProvider>
      </Provider>
    </Suspense>
  );
};

export default App;
